import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import { AdminModule } from './_layouts/admin/admin.module';
import { DataTablesModule } from 'angular-datatables';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';

import { HttpRequestService } from './_common/http-request.service';
import { AlertService, AuthenticationService, UserService } from './_services/index';
import { AlertComponent } from './_directives/alert.component'

import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { LoginComponent } from './_components/login/login.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { CoinConfigComponent } from './_components/coinconfig/coinconfig.component';
import { CoinEventsComponent } from './_components/coinevents/coinevents.component';
import { LineGroupComponent } from './_components/linegroup/linegroup.component';
import { AdminComponent } from './_layouts/admin/admin.component';
import { AdminHeaderComponent } from './_layouts/admin/admin-header/admin-header.component';
import { AdminLeftSideComponent } from './_layouts/admin/admin-left-side/admin-left-side.component';

import { AdminFooterComponent } from './_layouts/admin/admin-footer/admin-footer.component';
import { AdminControlSidebarComponent } from './_layouts/admin/admin-control-sidebar/admin-control-sidebar.component';
import { LogoutComponent } from './_components/logout/logout.component';
import { UserComponent } from './_components/user/user.component';
import { AddUserComponent } from './_components/user/adduser/adduser.component';
import { ResetpasswordComponent } from './_components/user/resetpassword/resetpassword.component';
import { ChangePasswordComponent } from './_components/user/changepassword/changepassword.component';
import { ErrorComponent } from './_components/error/error.component';
import { EqualValidatorDirective } from './_directives/equal-validator.directive';
import { MessageComponent } from './_components/message/message.component';
import { CoinConfigService } from './_services/coinconfig.service';
import { CoinEventsService } from './_services/coinevents.service';
import { LineGroupService } from './_services/linegroup.service';
import { MailTemplateComponent } from './_components/mail-template/mail-template.component';

import { AddLineBotComponent } from './_components/line-bot-account/add-line-bot-account/add-line-bot-account.component';
import { EditCoinComponent } from './_components/coinconfig/edit-coin/edit-coin.component';
import { AddCoinEventsComponent } from './_components/coinevents/add-coin-events/add-coin-events.component';
import { EditCoinEventsComponent } from './_components/coinevents/edit-coin-events/edit-coin-events.component';

import { TwitterComponent } from './_components/twitter/twitter.component';
import { AddTwitterComponent } from './_components/twitter/add-twitter/add-twitter.component';
import { ModulesComponent } from './_components/modules/modules.component';
import { AddModulesComponent } from './_components/modules/add-modules/add-modules.component';
import { EditModulesComponent } from './_components/modules/edit-modules/edit-modules.component';
import { ModulesFunctionsComponent } from "./_components/modules-functions/modules-functions.component";

import { AutoTradeCoinConfigComponent } from './_components/auto-trade-coin-config/auto-trade-coin-config.component';
import { AutoTradeEditCoinComponent } from './_components/auto-trade-coin-config/auto-trade-edit-coin/auto-trade-edit-coin.component';
import { BinanceApiComponent } from './_components/binance-api/binance-api.component';
import { AutoTradeHistoryComponent } from './_components/auto-trade-history/auto-trade-history.component';

import { AutoTradeCoinConfigService } from './_services/autotradecoinconfig.service';
import { BinanceApiService } from './_services/binancapi.service';
import { AutoTradeHistoryService } from './_services/auto-trade-history.service';

import { IosAppUsersComponent } from './_components/ios-app-user/ios-app-user.component';
import { AddIosAppUserComponent } from './_components/ios-app-user/add-ios-app-user/add-ios-app-user.component';
import { EditIosAppUserComponent } from './_components/ios-app-user/edit-ios-app-user/edit-ios-app-user.component';
import { IosAppUserService } from './_services/ios-app-user.service';
import { IosUserChannelService } from './_services/ios-user-channel.service';
import { IosUserEventService } from './_services/ios-user-event.service';
import { MailTemplateService } from './_services/mail-template.service';
import { ModulesService } from './_services/modules.service';

import { AngularReduxRequestOptions } from './_common/angular-redux-request-options';
import { LoaderComponent } from './_common/loader/loader.component';
import { ConfirmComponent } from './_common/confirm/confirm.component';
import { AlertBoxComponent } from './_common/alert-box/alert-box.component';
import { LoaderService } from './_common/loader/loader.service';
import { httpServiceFactory } from './_factories/http-service-factory';
import { Router, RouterModule } from '@angular/router';
import { LineBotService } from './_services/line-bot.service';
import { LineUserComponent } from './_components/line-user/line-user.component';
import { LineBotAccountComponent } from './_components/line-bot-account/line-bot-account.component';
import { AddLineUserComponent } from './_components/line-user/add-line-user/add-line-user.component';
import { LineUserService } from './_services/line-user.service';
import { MessageService } from './_services/message.service';
import { UppercaseDirective } from './_directives/uppercase.directive';
import { FocusDirective } from './_directives/focus.directive';
import { TradeHistoryComponent } from './_components/trade-history/trade-history.component';
import { TradeHistoryService } from './_services/trade-history.service';
import { IosUserChannelComponent } from './_components/ios-user-channel/ios-user-channel.component';
import { IosUserEventComponent } from './_components/ios-user-event/ios-user-event.component';
import { CoinCandlestickConditionComponent } from './_components/coin-candlestick-condition/coin-candlestick-condition/coin-candlestick-condition.component';
import { PopupCoinCandlestickConditionComponent } from './_components/coin-candlestick-condition/popup-coin-candlestick-condition/popup-coin-candlestick-condition.component';
import {CoinCandlestickConditionService} from "./_services/coin-candlestick-condition.service";
import { CrossPointsComponent } from './_components/cross-points/cross-points.component';
import { CrossPointsService } from './_services/cross-points.service';
import { CandlestickConditionDefaultComponent } from './_components/candlestick-condition-default/candlestick-condition-default.component';
import { CandlestickConditionDefaultService } from './_services/candlestick-condition-default.service';
import { RegisterComponent } from './_components/register/register.component';
import {RoleLoginGuardService} from "./_services/auth/role-login-guard.service";
import {AuthService} from "./_services/auth/auth.service";
import {AuthGuard} from "./_services/auth/auth-guard.service";
import { ForgotComponent } from './_components/forgot/forgot.component';
import { ConfirmPasswordComponent } from './_components/forgot/confirm-password/confirm-password.component';
import { ProfileUserComponent } from './_components/user/profile-user/profile-user.component';
import { ChangeProfileComponent } from './_components/user/profile-user/change-profile/change-profile.component';
import { EmaComponent } from './_components/ema/ema.component';
import { EmaService } from './_services/ema.service';
import { TwitterService } from './_services/twitter.service';
import { AlertsModule } from 'angular-alert-module';
import { AlertsService } from 'angular-alert-module';
import { TelegramChannelComponent } from './_components/telegram-channel/telegram-channel.component';
import { AddTelegramChannelComponent} from './_components/telegram-channel/add-telegram-channel/add-telegram-channel.component';
import { TelegramChannelService } from './_services/telegram-channel.service';
import { UserWebIosComponent } from './_components/user-web-ios/user-web-ios.component';
import { UserWebIosService } from './_services/user-web-ios.service';
import { CategoryMoneyComponent } from './_components/category-money/category-money.component';
import { CategoryMoneyService } from './_services/category-money.service';
import { AddCategoryMoneyComponent } from './_components/category-money/add-category-money/add-category-money.component';
import { EditCategoryMoneyComponent } from './_components/category-money/edit-category-money/edit-category-money.component';
import {SendSignalEventComponent} from "./_components/send-signal-event/send-signal-event.component";
import {PopupSettingSendSignalComponent} from "./_components/send-signal-event/popup-setting-send-signal/popup-setting-send-signal.component";
import {SendSignalService} from "./_services/send-signal.service";
import {DateTimePickerModule} from "ng-pick-datetime";
import { UserQuestionsComponent } from './_components/user-questions/user-questions.component';
import { ReplyQuestionComponent } from './_components/user-questions/reply-question/reply-question.component';
import { UserQuestionsService } from './_services/user-questions.service';
import { ShowModulesComponent } from './_components/register/show-modules/show-modules.component';
import { ChangeModuleComponent } from './_components/user/profile-user/change-module/change-module.component';
import { ManageCoinInCmcComponent } from './_components/send-signal-event/manage-coin-in-cmc/manage-coin-in-cmc.component';
import { PopupManageCoinInCmcComponent } from './_components/send-signal-event/manage-coin-in-cmc/popup-manage-coin-in-cmc/popup-manage-coin-in-cmc.component';
import { PopupShowListCoinComponent } from './_components/send-signal-event/popup-show-list-coin/popup-show-list-coin.component';
import {ManageCoinSendForUserComponent} from "./_components/send-signal-event/manage-coin-send-for-user/manage-coin-send-for-user.component";
import {PopupCoinSendForUserComponent} from "./_components/send-signal-event/manage-coin-send-for-user/popup-coin-send-for-user/popup-coin-send-for-user.component";
import {CoinSendPriceUserComponent} from "./_components/send-signal-event/coin-send-price-user/coin-send-price-user.component";

@NgModule({
    declarations: [

        AppComponent,
        LoginComponent,
        DashboardComponent,
        CoinConfigComponent,
        CoinEventsComponent,
        LineGroupComponent,
        LineBotAccountComponent,
        AlertComponent,
        AdminComponent,
        AdminHeaderComponent,
        AdminLeftSideComponent,
        AdminFooterComponent,
        AdminControlSidebarComponent,
        LogoutComponent,
        UserComponent,
        AddUserComponent,
        ResetpasswordComponent,
        ChangePasswordComponent,
        ErrorComponent,
        EqualValidatorDirective,
        MessageComponent,
        EditCoinComponent,
        AddLineBotComponent,
        AddCoinEventsComponent,
        EditCoinEventsComponent,

        IosAppUsersComponent,
        AddIosAppUserComponent,
        EditIosAppUserComponent,

        LoaderComponent,
        ConfirmComponent,
        AlertBoxComponent,
        LineUserComponent,
        AddLineUserComponent,
        UppercaseDirective,
        FocusDirective,
        TradeHistoryComponent,
        IosUserChannelComponent,
        IosUserEventComponent,
        CoinCandlestickConditionComponent,
        PopupCoinCandlestickConditionComponent,
        CrossPointsComponent,
        CandlestickConditionDefaultComponent,
        RegisterComponent,
        ForgotComponent,
        ConfirmPasswordComponent,
        ProfileUserComponent,
        ChangeProfileComponent,
        EmaComponent,

        TwitterComponent,
        AddTwitterComponent,
        TelegramChannelComponent,
        AddTelegramChannelComponent,
        MailTemplateComponent,
        ModulesComponent,
        AddModulesComponent,
        EditModulesComponent,
        UserWebIosComponent,
        ModulesFunctionsComponent,
        CategoryMoneyComponent,
        AddCategoryMoneyComponent,
        EditCategoryMoneyComponent,
        UserQuestionsComponent,
        ReplyQuestionComponent,
        AutoTradeCoinConfigComponent,
        AutoTradeEditCoinComponent,
        BinanceApiComponent,
        AutoTradeHistoryComponent,
        MailTemplateComponent,
        SendSignalEventComponent,
        PopupSettingSendSignalComponent,
        ShowModulesComponent,
        ChangeModuleComponent,
        PopupSettingSendSignalComponent,
        ManageCoinInCmcComponent,
        PopupManageCoinInCmcComponent,
        ManageCoinSendForUserComponent,
        PopupCoinSendForUserComponent,
        PopupShowListCoinComponent,
        CoinSendPriceUserComponent
    ],
    imports: [
        routing,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        BrowserModule,
        DataTablesModule,
        BootstrapModalModule.forRoot({ container: document.body }),
        RouterModule,
        DateTimePickerModule,
        AlertsModule.forRoot()
    ],
    providers: [
        RoleLoginGuardService,
        AuthService,
        AuthGuard,
        AuthenticationService,
        AlertService,
        UserService,
        CoinConfigService,
        CoinEventsService,
        LineGroupService,
        LineBotService,
        LineUserService,
        TwitterService,
        MessageService,
        LoaderService,
        HttpRequestService,
        TradeHistoryService,
        IosAppUserService,
        IosUserChannelService,
        IosUserEventService,
        CoinCandlestickConditionService,
        CandlestickConditionDefaultService,
        EmaService,
        CrossPointsService,
        LoaderService,
        TelegramChannelService,
        UserQuestionsService,
        {
            provide: HttpRequestService,
            useFactory: httpServiceFactory,
            deps: [XHRBackend, RequestOptions, LoaderService, Router, AlertsService]
        },
        MailTemplateService,
        ModulesService,
        UserWebIosService,
        CategoryMoneyService,
        AutoTradeCoinConfigService,
        BinanceApiService,
        AutoTradeHistoryService,
        SendSignalService
    ],
    entryComponents: [
        AddUserComponent,
        AddLineUserComponent,
        ResetpasswordComponent,
        AddLineBotComponent,
        EditCoinComponent,
        ConfirmComponent,
        AlertBoxComponent,
        AddCoinEventsComponent,
        EditCoinEventsComponent,
        AddIosAppUserComponent,
        EditIosAppUserComponent,
        PopupCoinCandlestickConditionComponent,
        ChangeProfileComponent,
        AddTwitterComponent,
        AddTelegramChannelComponent,
        AddModulesComponent,
        EditModulesComponent,
        AddCategoryMoneyComponent,
        EditCategoryMoneyComponent,
        ReplyQuestionComponent,
        AutoTradeEditCoinComponent,
        AddTelegramChannelComponent,
        PopupSettingSendSignalComponent,
        ShowModulesComponent,
        ChangeModuleComponent,
        PopupSettingSendSignalComponent,
        PopupManageCoinInCmcComponent,
        PopupCoinSendForUserComponent,
        PopupShowListCoinComponent
    ],
    bootstrap: [AppComponent]
})

export class AppModule{ }


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/app.module.ts